/**
 * 品牌配置加载工具
 * 利用构建时常量实现 tree-shaking，确保只打包当前品牌的代码
 *
 * @example
 * ```ts
 * import { loadBrandConfig } from '@/utils/loadBrandConfig'
 *
 * const config = loadBrandConfig({
 *   rocnovel: rocnovelConfig,
 *   oceread: ocereadConfig,
 *   ficmoon: ficmoonConfig,
 * })
 * ```
 */

// 声明构建时注入的品牌常量
declare const __BRAND__: 'rocnovel' | 'oceread' | 'ficmoon' | 'novelarc' | 'storyella' | 'silktale' | 'pearla' | 'fictora'

/**
 * 加载品牌配置
 *
 * 构建时会根据 __BRAND__ 常量进行 tree-shaking，
 * 只保留当前品牌的配置，移除其他品牌的配置
 */
export function loadBrandConfig<T>(configs: {
  rocnovel: T
  oceread: T
  ficmoon: T
  novelarc: T
  storyella: T
  silktale: T
  pearla: T
  fictora: T
}): T {
  // 这个条件判断会在构建时被优化掉
  if (__BRAND__ === 'rocnovel')
    return configs.rocnovel
  if (__BRAND__ === 'oceread')
    return configs.oceread
  if (__BRAND__ === 'ficmoon')
    return configs.ficmoon
  if (__BRAND__ === 'storyella')
    return configs.storyella
  if (__BRAND__ === 'silktale')
    return configs.silktale
  if (__BRAND__ === 'pearla')
    return configs.pearla
  if (__BRAND__ === 'fictora')
    return configs.fictora
  return configs.novelarc
}

/**
 * 加载品牌专属组件
 *
 * 构建时会根据 __BRAND__ 常量进行 tree-shaking，
 * 只保留当前品牌的组件，移除其他品牌的组件
 */
export function loadBrandComponent<T>(components: {
  rocnovel: T
  oceread: T
  ficmoon: T
  novelarc: T
  storyella: T
  silktale: T
  pearla: T
  fictora: T
}): T {
  if (__BRAND__ === 'rocnovel')
    return components.rocnovel
  if (__BRAND__ === 'oceread')
    return components.oceread
  if (__BRAND__ === 'ficmoon')
    return components.ficmoon
  if (__BRAND__ === 'storyella')
    return components.storyella
  if (__BRAND__ === 'silktale')
    return components.silktale
  if (__BRAND__ === 'pearla')
    return components.pearla
  if (__BRAND__ === 'fictora')
    return components.fictora
  return components.novelarc
}
